var echarts = require('echarts/lib/echarts');

require('./liquidFillSeries');
require('./liquidFillView');


echarts.registerVisual(
    echarts.util.curry(
        require('echarts/lib/visual/dataColor'), 'liquidFill'
    )
);



//////////////////
// WEBPACK FOOTER
// ./~/_echarts-liquidfill@2.0.6@echarts-liquidfill/src/liquidFill.js
// module id = 858
// module chunks = 128